import s from './card-grid.module.css'

type Props = {
  children: React.ReactNode
}

export const CardGrid = ({ children }: Props) => {
  return <div className={s.grid}>{children}</div>
}
